<template>
  <div class="invoice-fixed-header">
    <div class="header-center">
      <img
        src="../../../assets/imgs/common/header-logo-blue.png"
        class="ssq-logo"
        @click="goHome"
      />
      <div class="divide-line" v-if="showPageTitle"></div>
      <div class="invoice-page-title" v-if="showPageTitle">确认付款</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'invoice-fixed-header',
  props: {
    showPageTitle: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  methods: {
    goHome() {
      this.$router.replace({
        name: 'index',
      });
    },
  },
};
</script>

<style lang="less" scoped>
.invoice-fixed-header {
  display: flex;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  height: 68px;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(34, 38, 46, 0.08);
  z-index: 1001;
  .header-center {
    width: 800px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    .ssq-logo {
      height: 28px;
      cursor: pointer;
    }
    .divide-line {
      width: 1px;
      height: 28px;
      background: #dadde2;
      margin: 0 16px;
    }
    .invoice-page-title {
      font-size: 18px;
      font-weight: 400;
      color: #22262e;
      line-height: 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoice-manage/components/invoice-fixed-header.vue